import { registerEventHandlers } from "@/events";

import "@/modules/base";
import "@/modules/no-legacy";
import "@/modules/abtest-body-class";
import "@/modules/leaving-popup";
import "@/modules/lazyload";
import "@/modules/load-plans";

import { setWdyhauTrafficCookie } from "@/modules/wdyhau-survey";
import { deleteTrialessCouponCookie } from "@/modules/signup-discount";
import { init as initAdjustUrls } from "@/utils/adjust-links";

import "@/features/animate/init";

import "@/styles/homepage";

import createHomepage from "@/pages/homepage/init";
import initHeader from "@/features/header/header";
import initStickyHeader from "@/features/header/sticky-header";
import { initSalesBanner } from "@/features/banner/init";
import { eventHandlers as abTestEventHandlers } from "@/modules/abtest-toggle";
import { eventHandlers as categoryExplorerEventHandlers } from "@/features/category-explorer/init";
import "@/features/internal-links-section/init";

registerEventHandlers([
  abTestEventHandlers,
  categoryExplorerEventHandlers
]);

initHeader();
initStickyHeader();
initSalesBanner();
createHomepage();
deleteTrialessCouponCookie();
setWdyhauTrafficCookie();
initAdjustUrls();
